import AuthEndpoints from '../endpoints/auth/AuthEndpoints';
import QnaEndpoints from '../endpoints/member/QnaEndpoints';
import NoticeEndpoints from './member/NoticeEndpoints';
import NotificationEndpoints from './member/NotificationEndpoints';
import AccountEndpoints from './member/AccountEndpoints';
import ImageManagementEndpoints from './image/ImageManagementEndpoints';
import SellerBatteryEndpoints from '../endpoints/seller/SellerBatteryEndpoints';
import SellerInquiryEndpoints from '../endpoints/seller/SellerInquiryEndpoints';
import BuyerBatteryEndpoints from '../endpoints/buyer/BuyerBatteryEndpoints';
import BuyerInquiryEndpoints from '../endpoints/buyer/BuyerInquiryEndpoints';
import AdminNoticeEndpoints from '../endpoints/admin/AdminNoticeEndpoints';
import AdminQnaEndpoints from '../endpoints/admin/AdminQnaEndpoints';
import AdminMembersEndpoints from '../endpoints/admin/AdminMembersEndpoints';
// 다른 엔드포인트 파일들을 import

const API_ENDPOINTS = {
  ...AuthEndpoints,
  ...QnaEndpoints,
  ...NoticeEndpoints,
  ...NotificationEndpoints,
  ...AccountEndpoints,
  ...ImageManagementEndpoints,
  ...SellerBatteryEndpoints,
  ...SellerInquiryEndpoints,
  ...BuyerBatteryEndpoints,
  ...BuyerInquiryEndpoints,
  ...AdminNoticeEndpoints,
  ...AdminQnaEndpoints,
  ...AdminMembersEndpoints,
};

export default API_ENDPOINTS;
